import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App/index';
import * as serviceWorker from './serviceWorker';
import reducer from './store/reducer';
import config from './config';
import './assets/scss/style.scss';

axios.interceptors.response.use(
    res => res,
    err => {
        const status = err && err.response && err.response.status;
        const body = err && err.response && err.response.data;
        const msg = body && body.message;
        const isTokenExpired = status === 401
            || status === 402
            || (typeof body === 'string' && body.indexOf('TokenExpiredError') !== -1)
            || (body && (body.name === 'TokenExpiredError' || body.error === 'TokenExpiredError'))
            || (msg && (msg.name === 'TokenExpiredError' || (typeof msg === 'string' && msg.indexOf('TokenExpiredError') !== -1)));
        if (isTokenExpired && window.location.pathname !== '/login') {
            localStorage.clear();
            window.location.href = '/login';
        }
        return Promise.reject(err);
    },
);
//

//config.entity == 1 ? import ('./assets/scss/style.scss').then() : import( './assets/scss/style-seunsm.scss').then();


const store = createStore(reducer);

const app = (
    <Provider store={store}>
        <BrowserRouter basename={config.basename}>
            <App />
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
